import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MessageBoxViewModelType from '@/ViewModels/Controls/MessageBoxViewModel';
import LabelType from '@/Controls/Label';
import WindowType from '@/Controls/Window';
import ButtonType from '@/Controls/Button';
import ImageType from '@/Controls/Image';

export default class MessageBox extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private Window = ComponentManager.getControl<typeof WindowType>('Window');
    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    private Button = ComponentManager.getControl<typeof ButtonType>('Button');
    private jQueryControl: JQuery;

    private window: WindowType;
    private image: ImageType;
    private label: LabelType;
    private data: LabelType;
    private stack: LabelType;
    private buttons: Array<ButtonType>;

    public constructor(private viewModel: MessageBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'messagebox',

            loader: this.context.isBusy,

            controlIdent: this.identifier,

            tooltip: this.context.tooltip,

            invalid: this.context.invalidationText,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    if (!String.isNullOrEmpty(this.viewModel.style))
                        styles.push(this.viewModel.style);

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.context.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.window != null) {
            this.window = new this.Window(this.viewModel.window, this.jQueryControl);

            let windowTuple = this.window.getTuple();
            windowTuple.control.appendTo(this.jQueryControl);

            this.defineComputed(() => {
                let content = this.viewModel.window.content();

                if (content != null && content.length > 0) {
                    let body = $('<div class="body msgB-flex">').appendTo(content);
                    let footer = $('<div class="footer"></div>').appendTo(content);

                    if (this.viewModel.image != null) {
                        let imgContainer = $('<div class="imgContainer" >');
                        this.image = new this.Image(this.viewModel.image);
                        let tuple = this.image.getTuple();

                        tuple.control.appendTo(imgContainer);
                        imgContainer.appendTo(body);
                    }

                    let bodyContentContainer = $('<div class="bodyContainer">');

                    if (this.viewModel.labelArray != null && this.viewModel.labelArray.length > 0) {
                        for (var i = 0; i < this.viewModel.labelArray.length; i++) {
                            if (this.viewModel.labelArray[i] != null) {
                                this.label = new this.Label(this.viewModel.labelArray[i].label);
                                let tuple = this.label.getTuple();

                                tuple.control.appendTo(bodyContentContainer);
                            }

                            if (this.viewModel.labelArray[i].list != null && this.viewModel.labelArray[i].list.length > 0) {
                                let ul = $("<ul class='c-textlist'>").appendTo(bodyContentContainer);
                                this.viewModel.labelArray[i].list
                                    .map((text) => {
                                        return $("<li></li>").text(text);
                                    })
                                    .forEach((el) => {
                                        ul.append(el);
                                    });
                            }

                            $('<div class="clear">').appendTo(bodyContentContainer);

                        }
                    }
                    else {

                        if (this.viewModel.label != null) {
                            this.label = new this.Label(this.viewModel.label);
                            let tuple = this.label.getTuple();

                            tuple.control.appendTo(bodyContentContainer);
                        }

                        if (this.viewModel.textList != null && this.viewModel.textList.length > 0) {
                            let ul = $("<ul class='c-textlist'>").appendTo(bodyContentContainer);
                            this.viewModel.textList
                                .map((textItem) => {
                                    return $("<li></li>").text(textItem);
                                })
                                .forEach((el) => {
                                    ul.append(el);
                                });
                        }

                        $('<div class="clear">').appendTo(bodyContentContainer);

                    }

                    if (this.viewModel.data != null) {
                        this.data = new this.Label(this.viewModel.data, $('<pre class="c-data">').appendTo(bodyContentContainer));
                        let tuple = this.data.getTuple();
                    }

                    if (this.viewModel.stack != null) {
                        this.stack = new this.Label(this.viewModel.stack, $('<pre class="c-stack">').appendTo(bodyContentContainer));
                        let tuple = this.stack.getTuple();
                    }

                    bodyContentContainer.appendTo(body);

                    this.applyBindings(this.jQueryControl.parents('.c-window').first(), {
                        describedBy: this.definePureComputed({
                            read: () => {
                                return bodyContentContainer;
                            }
                        })
                    });

                    this.buttons = [];

                    for (let i = 0; i < this.viewModel.buttons.length; i++) {
                        let button = new this.Button(this.viewModel.buttons[i], $('<div>').appendTo(footer));
                        let tuple = button.getTuple();

                        this.buttons.push(button);
                    }
                }
            });
        }
    }
}

ComponentManager.setControl('MessageBox', MessageBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');